import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ApiFehler } from "./api/client";
import { App } from "./App";
import "./styles/tokens.css";
import "./styles/app.css";

const abfragen = new QueryClient({
  defaultOptions: {
    queries: {
      // Ein 401/403/404 wird nicht wiederholt — es wird beim zweiten Mal nicht besser.
      retry: (n, f) => !(f instanceof ApiFehler && f.status >= 400 && f.status < 500) && n < 2,
      refetchOnWindowFocus: true,
      staleTime: 10_000,
    },
  },
});

// Offline-Fähigkeit (public/sw.js). Nur im gebauten Stand: im Entwicklungsserver hielte
// der Service Worker alte Module fest.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => undefined); });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
